declare global {
  interface Window {
    kiwi: Kiwi;
  }
}

export interface Kiwi {
  screen: KiwiScreen;
  /**
   * Získá aktuální verzi Player Lighter JS API. Formát je kompatibilní s semver.
   */
  getApiVersion(): Promise<string>;
}

export interface KiwiScreen {
  /**
   * Získá instanci obrazovky. Pokud identifikátor obrazovky pro
   * neexistuje, pak je vráceno undefined.
   * @param id Identifikátor obrazovky.
   */
  get(id: 1 | 2 | number): Promise<Screen | undefined>;
}

export interface Region {
  /**
   * Přepne na zvolený target, i když target neexistuje. Target může obsahovat i podmínku přepnutí tj. primary=>kiosk.
   * Pokud požadovaný target již běží nebo není splněna podmínka, tak se po zavolání funkce nic nestane.
   * @param target Název targetu, na který se má přepnout např. primary, kiosk, overlay...
   */
  switchTarget(target: string): Promise<void>;
}

export interface Screen extends Region {}

let jsApi: JsApi | null = null;

export class JsApi {
  private constructor(private kiwi: any) { }

  async switchTarget(target: string): Promise<void> {
    const screen = await this.kiwi.screen.get(1);
    if (screen) {
      await screen.switchTarget(target);
    }
  }

  static use(): JsApi {
    if (!window.kiwi) {
      throw new Error('Kiwi API is not available');
    }
    if (jsApi) {
      return jsApi;
    }
    jsApi = new JsApi(window.kiwi);
    return jsApi;
  }
}
